import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * 统一登录：跳转若依子应用登录页（同域 /admin/login）
 * 若依成功登录后需调用 syncMainAppJwt（见 RuoYi-Vue3/src/utils/mainAppAuthSync.js）
 */
const LoginRuoYiRedirect: React.FC = () => {
  const [searchParams] = useSearchParams()
  const [err, setErr] = useState<string | null>(null)

  useEffect(() => {
    try {
      const redirect = searchParams.get('redirect') || '/'
      if (!redirect.startsWith('/') || redirect.startsWith('//')) {
        setErr('非法 redirect 参数')
        return
      }
      const qs = new URLSearchParams({ redirect: redirect || '/' }).toString()
      const target = `${window.location.origin}/admin/login?${qs}`
      window.location.replace(target)
    } catch (e: any) {
      setErr(e?.message || '跳转失败')
    }
  }, [searchParams])

  if (err) {
    return (
      <div className="auth-page" style={{ padding: 24, textAlign: 'center' }}>
        {err}
      </div>
    )
  }

  return (
    <div className="auth-page" style={{ padding: 24, textAlign: 'center' }}>
      正在跳转到系统登录…
    </div>
  )
}

export default LoginRuoYiRedirect
